module.exports = __webpack_public_path__ + "img/progress_077.4243ba7f.png";